import { Box, Chip } from "@mui/material";
import { useState } from "react";
import useColors from "../../../../../api/hooks/useColors";
import TagsDropdown from "../../components/TagsDropDown/TagsDropdown";

export default function MoreTagsChip({ entity, tags, width }) {
  const colors = useColors();
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);

  return (
    <Box>
      <Chip
        label={`+${tags.length}`}
        size="small"
        onClick={(event) => setMenuAnchorEl(event.currentTarget)}
        sx={{
          backgroundColor: colors.grey_100,
          color: colors.text_secondary,
          fontSize: "12px",
          fontWeight: 500,
          height: "24px",
          width: `${width}px`,
          borderRadius: "6px",
          cursor: "pointer",
          "&:hover": {
            backgroundColor: colors.grey_200,
          },
        }}
      />
      {menuAnchorEl && (
        <TagsDropdown
          selectedEntities={[entity]}
          menuAnchorEl={menuAnchorEl}
          setMenuAnchorEl={setMenuAnchorEl}
        />
      )}
    </Box>
  );
}
